import { PDFDownloadLink } from '@react-pdf/renderer'
import FabricaPDF from './FabricaPDF'
import { CustomButton } from 'components/ui'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useTotalMo } from 'hooks/useTotalMo'
import { getCurrentDay } from 'utils/formatsDate'
import Loader from 'components/Spinner/Loader'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

const FabricaPdfButton = ({ modulos }) => {
  const { idProject } = useParams()
  const queryClient = useQueryClient()
  const { totalMo, totalMoByVinculo } = useTotalMo()
  const { importProject } = modulos

  const data = queryClient.getQueryData(['project', idProject])

  const fechaActual = getCurrentDay()
  const titlePdf = `${data?.data?.proyecto?.name}_${fechaActual}`
  return (
    <div className="button-container-pdf">
      <CustomButton className="btn-center">
        <PDFDownloadLink
          document={
            <FabricaPDF
              modulos={modulos}
              today={fechaActual}
              titlePdf={data?.data?.proyecto?.name}
              totalImportProject={importProject + Number(totalMo)}
              totalMoByVinculo={totalMoByVinculo}
            />
          }
          fileName={`${titlePdf}.pdf`}
          style={{
            textDecoration: 'none',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? (
              <Loader size={14} color="white" />
            ) : (
              <>
                <PictureAsPdfIcon /> Generar PDF
              </>
            )
          }
        </PDFDownloadLink>
      </CustomButton>
    </div>
  )
}

export default FabricaPdfButton
